import { useState } from 'react';
import React from 'react'
import { Row, Col, Card, CardBody, CardHeader, Button, Collapse, Table, FormGroup, Label, Input } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import uuid from 'react-uuid';
import OpenActionSummaryItem from '../AllFarmsSummary/OpenActionSummaryItem';
import moment from "moment";
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

const OpenActionSummary = ({ openActionSupplierList, openActionList, openActionsList }) => {
    const [isOpen, setIsOpen] = useState(true); const [isIconUp, setIsIconUp] = useState(true); const [farmId, setFarmId] = useState(0); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [tempOpenActionList, setTempOpenActionList] = useState(openActionList); const [openActionItems, setOpenActionItems] = useState(openActionList);
    const [tempOpenActionsList, setTempOpenActionsList] = useState(openActionsList); const [openActionsItems, setOpenActionsItems] = useState(openActionsList);
    const [tempOpenActionSupplierList, setTempOpenActionSupplierList] = useState(openActionSupplierList); const [openActionSupplieritems, setOpenActionSupplieritems] = useState(openActionSupplierList);
    const toggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const [isGroupBy, setIsGroupBy] = useState(false); const [isExpand, setIsExpand] = useState(false);

    const handleFarmIdChange = (e) => {
        setFarmId(e.target.value)
        if (parseInt(e.target.value) == 0) {
            setOpenActionItems(tempOpenActionList);
            setOpenActionsItems(tempOpenActionsList);
            setOpenActionSupplieritems(tempOpenActionSupplierList);
        }
        else {
            var list = tempOpenActionList.filter(x => x.farmId == parseInt(e.target.value));
            var list1 = tempOpenActionSupplierList.filter(x => x.id == parseInt(e.target.value));
            var list2 = tempOpenActionsList.filter(x => x.farmId == parseInt(e.target.value));
            setOpenActionItems(list);
            setOpenActionSupplieritems(list1);
            setOpenActionsItems(list2);
        }
    }

    const exportFarmListToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportExcel = async (e) => {
        const response = await axios.get(
            '/api/allFarmsSummary/GenerateReportOpenActionsExcel/', {
                params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "OpenActions.xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }

    const exportFarmListToPdf = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportReportPdf();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportReportPdf = async (e) => {
        const response = await axios.get(
            '/api/allFarmsSummary/GenerateReportOpenActionsPDF/', {
                params: { userId: userId, farmId: farmId }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/pdf" })
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "OpenActions.pdf";
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    return (
        <div>
            <Row style={{ marginTop: `15px` }}>
                <Col>
                    <Card>
                        <CardHeader className="item-header" onClick={toggle}>
                            <Row>
                                <Col sm="11"><h6>Open Actions
                                    <Button style={{ float: "right", background: "none", border: "none" }} onClick={(e) => exportFarmListToExcel(e)} value="Export" placeholder="">
                                        <img src="/images/Excel_icon.png" className="card_icon" ></img>
                                    </Button>
                                    {/*<Button style={{ float: "right", background: "none", border: "none", marginRight: "-20px" }} onClick={(e) => exportFarmListToPdf(e)} value="Export" placeholder="">*/}
                                    {/*    <img src="/images/PDF_icon.png" className="card_icon" ></img>*/}
                                    {/*</Button>*/}
                                </h6></Col>
                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                            </Row>
                        </CardHeader>
                        <CardBody style={{ height: '350px',overflowY:'auto' }}>
                            <Collapse isOpen={isOpen}>
                                <div>
                                    <Row>
                                        <Col sm="4">
                                            <Label for="farmId">Select Supplier</Label>
                                            {openActionSupplierList == undefined && <p><em>Loading...</em></p>}
                                            {openActionSupplierList != undefined && openActionSupplieritems != null &&
                                                <Input className="validate" type="select" value={farmId} onChange={(e) => handleFarmIdChange(e)} name="farmId" id="farmId">
                                                    <option key={uuid()} value="0">All Suppliers</option>
                                                    {openActionSupplierList.map(items =>
                                                        <option key={uuid()} value={items.id}>{items.name}</option>
                                                    )}
                                                </Input>
                                            }
                                        </Col>
                                        <Col sm="4">
                                            <br/>
                                            <Input type="checkbox" checked={isGroupBy} onChange={(e) => setIsGroupBy(!isGroupBy)} name="isGroupBy" id="isGroupBy" />&nbsp;
                                            <Label for="name">Group By Supplier</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div>
                                            {isGroupBy && 
                                                openActionSupplieritems.map(summary =>
                                                    <OpenActionSummaryItem expand={isExpand} key={summary.id} itemObj={summary} itemObjList={openActionItems.filter(x => x.farmId == summary.id)}></OpenActionSummaryItem>
                                                )
                                            }
                                        </div>
                                        <div>
                                            {
                                                !isGroupBy &&
                                                <table id="tblDocumentList" className="table borderless table-striped border-top-bottom">
                                                    <thead className="textAlignCenter">
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Due Date</th>
                                                            <th>Farm Name</th>
                                                            <th>Item</th>
                                                            <th>Description</th>
                                                        </tr>

                                                    </thead>
                                                    <tbody className="documentList textAlignCenter" id="documentList">
                                                            {openActionsItems != undefined && openActionsItems.length > 0 && openActionsItems.map(summary =>
                                                            <tr key={uuid()}>
                                                                <td>{summary.uniqueIdentifier}</td>
                                                                    <td>{summary.actionTypeName == "Improvement" ? moment(summary.dueDate).format('DD/MM/YYYY') : 'Ongoing / Management'}</td>
                                                                    <td>{summary.farmName}</td>
                                                                <td>{summary.itemName}</td>
                                                                <td>{summary.description}</td>
                                                            </tr>
                                                        )
                                                        }
                                                    </tbody>
                                                </table>
                                            }
                                        </div>
                                    </Row>
                                </div>
                            </Collapse>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
export default OpenActionSummary;